import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AddRide = () => {
    // Retrieve the searchData passed via navigate
    const location = useLocation();
    const searchData = location.state;  // Get the passed data (searchData)
    const navigate = useNavigate();

    const [rideDetails, setRideDetails] = useState({
        from: searchData?.from || '',
        to: searchData?.to || '',
        date: searchData?.date || '',
        time: searchData?.time || '',
        femaleOnly: false
    });

    const handleChange = (e) => {
        setRideDetails({ ...rideDetails, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/rides/add`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token'),
                },
                body: JSON.stringify(rideDetails),
            });

            const result = await response.json();

            if (result.success) {
                alert('Ride added successfully');
                // Redirect to home (search) page
                navigate('/home');
            } else {
                alert(result.message || 'Failed to add ride');
            }
        } catch (error) {
            console.error('Error adding ride:', error);
            alert('Error adding ride');
        }
    };

    return (
        <div className="ui-page">
            <div className="ui-container">
                <div className="ui-header">
                    <div>
                        <h1 className="ui-title">Add a ride</h1>
                        <p className="ui-subtitle">Post your ride so others can match with you.</p>
                    </div>
                    <div className="ui-actions">
                        <button className="ui-btn ui-btn-secondary" onClick={() => navigate('/home')}>Back</button>
                    </div>
                </div>

                <div className="ui-grid ui-grid-2" style={{ alignItems: 'start' }}>
                    <div className="ui-card">
                        <div className="ui-card-body">
                            <div className="ui-card-title">Safety & community</div>
                            <p className="ui-subtitle" style={{ marginTop: 0 }}>
                                Females can mark rides as female-only so they are visible only to female users for improved safety.
                            </p>
                            <div className="ui-divider" />
                            <ul className="ui-list">
                                <li>Share within the NITK community</li>
                                <li>Coordinate easily using Telegram</li>
                                <li>Reduce cost and carbon footprint</li>
                            </ul>
                        </div>
                    </div>

                    <div className="ui-card">
                        <div className="ui-card-body">
                            <div className="ui-card-title">Ride details</div>
                            <form onSubmit={handleSubmit} className="ui-stack" style={{ gap: '0.9rem' }}>
                                <div className="ui-field">
                                    <label className="ui-label" htmlFor="from">From</label>
                                    <select id="from" className="ui-select" name="from" value={rideDetails.from} onChange={handleChange} required>
                                        <option value="">Select</option>
                                        <option value="NITK">NITK</option>
                                        <option value="Mangalore Airport">Mangalore Airport</option>
                                        <option value="Mangalore Junction Railway Station">Mangalore Junction Railway Station</option>
                                        <option value="Manglore Central Railway Station">Manglore Central Railway Station</option>
                                        <option value="Surathkal bus stand">Surathkal bus stand</option>
                                        <option value="Surathkal Railway Station">Surathkal Railway Station</option>
                                    </select>
                                </div>
                                <div className="ui-field">
                                    <label className="ui-label" htmlFor="to">To</label>
                                    <select id="to" className="ui-select" name="to" value={rideDetails.to} onChange={handleChange} required>
                                        <option value="">Select</option>
                                        <option value="NITK">NITK</option>
                                        <option value="Mangalore Airport">Mangalore Airport</option>
                                        <option value="Mangalore Junction Railway Station">Mangalore Junction Railway Station</option>
                                        <option value="Manglore Central Railway Station">Manglore Central Railway Station</option>
                                        <option value="Surathkal Bus stand">Surathkal bus stand</option>
                                        <option value="Surathkal Railway Station">Surathkal Railway Station</option>
                                    </select>
                                </div>
                                <div className="ui-field">
                                    <label className="ui-label" htmlFor="date">Date</label>
                                    <input id="date" className="ui-input" type="date" name="date" value={rideDetails.date} onChange={handleChange} required />
                                </div>
                                <div className="ui-field">
                                    <label className="ui-label" htmlFor="time">Time</label>
                                    <input id="time" className="ui-input" type="time" name="time" value={rideDetails.time} onChange={handleChange} required />
                                </div>

                                <label className="ui-label" style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', fontWeight: 800 }}>
                                    <input
                                        type="checkbox"
                                        name="femaleOnly"
                                        checked={rideDetails.femaleOnly}
                                        disabled={String(localStorage.getItem('gender') || '').toLowerCase() !== 'female'}
                                        onChange={(e) => setRideDetails({ ...rideDetails, femaleOnly: e.target.checked })}
                                    />
                                    Show this ride only to female users (enabled only for female users)
                                </label>

                                <button type="submit" className="ui-btn ui-btn-success ui-btn-block">
                                    Add ride
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddRide;
